import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faFilePdf, faExternalLinkAlt, faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { CSVLink } from 'react-csv';  // Import react-csv for CSV export
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MultiSelect } from "react-multi-select-component";
import config from '../config';
import CobraSummary from '../summary/CobraSummary';
import { useReactToPrint } from 'react-to-print';
import EmployeeBenefitsSummary from '../summary/employeBenefits/EmployebenefitsSummary';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const formatSubmittedAt = (value) => {
    if (!value) return '';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleString('en-US');
};

const AdminDataPanel = ({ clientName, salesforceCaseId,selectedOptionsProducts ,selectedOptionsStatus ,selectedOptionsCrmName, selectedOptionsDate,selectedSalesReps, selectedSource ,selectedOptionsOwner,adminData, dataLoading}) => {
    // const [adminData, setAdminData] = useState([]);
     const [filteredData, setFilteredData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [showExportOptions, setShowExportOptions] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
    const [selectedCaseId, setSelectedCaseId] = useState(null); // State to hold the selected case ID
    const [selectedCaseType, setSelectedCaseType] = useState(null); // State to hold the selected case Type
    const printFunctionRef = useRef(null); // Ref to hold the CobraSummary component
    const [summaryLoading, setSummaryLoading] = useState(false);

    // Fetch admin data from API
    // const getAdmin = async () => {
    //     try {
    //         const response = await axios.get("https://dev-renewalapi.claritybenefitsolutions.com/api/renewalcases");
    //         setAdminData(response.data);
    //         setFilteredData(response.data); // Initialize filtered data
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    // useEffect(() => {
    //     getAdmin();
    // }, []);

    const handleCasePrint = (row) => {
        const selectedCaseId = row.caseId;
        const selectedCaseType = row.caseType;
    
        console.log(selectedCaseId);
        console.log(selectedCaseType);
    
        setSelectedCaseId(selectedCaseId); // Set the selected case ID
        setSelectedCaseType(selectedCaseType); // Set the selected case type
        setSummaryLoading(true);
    };

    useEffect(() => {
        if (selectedCaseId && selectedCaseType) {
            setTimeout(() => {
                setSummaryLoading(false);
                handlePrint(); 
                
            }, 5000);
        }
    }, [selectedCaseId, selectedCaseType]);

    const handlePrint = useReactToPrint({
        contentRef: printFunctionRef, 
        onAfterPrint: () => {
            console.log('Print successful');
            setSelectedCaseId(null);
        },
    });


    useEffect(() => {
        // Filter data based on both client name and global search
        const filtered = adminData.filter(item => {
            const matchesClientName = clientName === "" || item.employerName.toLowerCase().includes(clientName.toLowerCase());
            const matchesSalesforceCaseId = salesforceCaseId === "" || item.sfCaseId.toLowerCase().includes(salesforceCaseId.toLowerCase());
            const matchesSelectedOptionsProducts = selectedOptionsProducts.length === 0 || 
            selectedOptionsProducts.some(option => 
                item.products && item.products.toLowerCase().includes(option.value.toLowerCase())
            );
            // const matchesSelectedOptionsStatus = selectedOptionsStatus.length === 0 || 
            // selectedOptionsStatus.some(option => 
            //     item.caseStatus && item.caseStatus.toLowerCase().includes(option.value.toLowerCase())
            // );
            const matchesSelectedOptionsStatus = selectedOptionsStatus.length === 0 || 
    selectedOptionsStatus.some(option => 
        item.caseStatus && item.caseStatus.toLowerCase() === option.value.toLowerCase()
    );

            const matchesCrmNames = selectedOptionsCrmName.length === 0 || 
             selectedOptionsCrmName.some(option => 
                item.crmName && item.crmName.toLowerCase().includes(option.value.toLowerCase())
            );
              
            const matchesSelectedOptionsDate = selectedOptionsDate.length === 0 || 
            selectedOptionsDate.some(option => 
                item.renewalDate && item.renewalDate.toLowerCase().includes(option.value.toLowerCase())
            );
            
            const matchesSelectedSalesReps = selectedSalesReps.length === 0 || 
            selectedSalesReps.some(option => 
                item.salesRepName && item.salesRepName.toLowerCase().includes(option.value.toLowerCase())
            );

            const matchesSelectedSource = selectedSource.length === 0 || 
            selectedSource.some(option => 
                item.qbnpmFileSource && item.qbnpmFileSource.toLowerCase().includes(option.value.toLowerCase())
            );

            const matchesSelectedOptionOwner = selectedOptionsOwner.length === 0 || 
            selectedOptionsOwner.some(option => 
                item.caseOwnerName && item.caseOwnerName.toLowerCase().includes(option.value.toLowerCase())
            );


            const matchesGlobalSearch = Object.values(item).some(val =>
                String(val).toLowerCase().includes(searchText.toLowerCase())
            );
            return matchesClientName && matchesSalesforceCaseId && matchesGlobalSearch && matchesSelectedOptionsProducts && matchesSelectedOptionsStatus && matchesCrmNames && matchesSelectedOptionsDate && matchesSelectedSalesReps && matchesSelectedSource && matchesSelectedOptionOwner;
        });


        // Apply sorting
        if (sortConfig.key) {
            filtered.sort((a, b) => {
                const aValue = a[sortConfig.key] || '';
                const bValue = b[sortConfig.key] || '';

                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    return sortConfig.direction === 'ascending' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                }
                if (typeof aValue === 'number' && typeof bValue === 'number') {
                    return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                }

                return 0;
            });
        }


         setFilteredData(filtered);
        setCurrentPage(1);  // Reset to page 1 after applying the search
    }, [searchText, clientName, salesforceCaseId, sortConfig, adminData, selectedOptionsProducts,selectedOptionsStatus,selectedOptionsCrmName,selectedOptionsDate, selectedSalesReps, selectedSource, selectedOptionsOwner]);  // Re-run the filter when these values change

    const handleSearch = (event) => {
        setSearchText(event.target.value);
    };



    // Handle change for entries per page
    const handlePerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page
    };

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        // Toggle direction if the same column is clicked again
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
        }
        return faSort;
    };


    const [expandedRow, setExpandedRow] = useState(null);

    const [expandedRowId, setExpandedRowId] = useState(null);
    const [expandedRowEmail, setExpandedRowEmail] = useState(null);

    const [expandedRowIdEmail, setExpandedRowIdEmail] = useState(null);


    //Email log
    const [emailLogs, setEmailLogs] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchEmailLogs = async (caseId) => {
        setLoading(true);
        try {
            const response = await fetch(`${config.API_URL}/EmailLogs/${caseId}`);
            const data = await response.json();
            setEmailLogs(data); // Assuming the API returns an array of email logs
        } catch (error) {
            console.error('Error fetching email logs:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleExpandClick = (caseId) => {
        // Call the provided handler to manage row expansion
        // handleRowExpandEmail(caseId);
        isRowExpandedEmail(caseId);

        if (expandedRowEmail !== caseId) {
            fetchEmailLogs(caseId); // Fetch email logs only if expanding the row
        } else {
            setEmailLogs([]); // Clear logs if collapsing
        }
    };
    
    
    const handleWccExport = async (row) => {
        try {
          
          const apiEndpoint = `${config.API_URL}/RenewalPortal/WccDataExport/${row.caseId}`;
     
          
          
     
          const response = await axios.post(apiEndpoint, {
           
          });
     
          
          
          alert("WCC export was successful!");
        } catch (error) {
          
          alert("There was an error with the WCC export. Please try again.");
        }
      };


      const handleRollClick = async (caseId) => {
        try {
            const patchData = [
                {
                    op: "replace",
                    path: "/rolloutStatus",
                    value: true
                }
            ];
    
            await axios.patch(
                `${config.API_URL}/RenewalCases/${caseId}`,
                patchData,
                {
                    headers: {
                        "Content-Type": "application/json-patch+json"
                    }
                }
            );
    
            setFilteredData(prev =>
                prev.map(item =>
                    item.caseId === caseId
                        ? { ...item, rolloutStatus: true }
                        : item
                )
            );
    
            alert("Case successfully Rolledout!");
        } catch (error) {
            console.error("Error updating Rolloutstatus:", error);
            alert("An error occurred while Rolling out the case.");
        }
    };

    
      const handleRowExpandEmail = (caseId) => {
        // Collapse the expanded row if it's currently open
        if (expandedRowEmail === caseId) {
            setExpandedRowEmail(null);
        } else {
            setExpandedRowEmail(caseId);
            setExpandedRow(null); // Collapse any expanded row
        }
        if (expandedRowEmail !== caseId) {
            fetchEmailLogs(caseId); // Fetch email logs only if expanding the row
        } else {
            setEmailLogs([]); // Clear logs if collapsing
        }
    };
    
    const handleRowExpand = (caseId) => {
        // Collapse the expanded email if it's currently open
        if (expandedRow === caseId) {
            setExpandedRow(null);
        } else {
            setExpandedRow(caseId);
            setExpandedRowEmail(null); // Collapse any expanded email
        }
    };
    
    // Checks if a row is expanded
    const isRowExpandedEmail = (caseId) => {
        return expandedRowEmail === caseId;
    };
    
    const isRowExpanded = (caseId) => {
        return expandedRow === caseId;
    };
    // const handleRowExpandEmail = (caseId) => {
    //     // Debugging to ensure correct row caseId

    //     setExpandedRowIdEmail(expandedRowIdEmail === caseId ? null : caseId);
    //     setExpandedRowEmail((prevRow) => (prevRow === caseId ? null : caseId));
    // };

    // // Checks if a row is expanded
    // const isRowExpandedEmail = (caseId) => {
        

    //     return expandedRowEmail === caseId;
    // };



    // const handleRowExpand = (caseId) => {
    //     // Debugging to ensure correct row caseId
    //     setExpandedRowId(expandedRowId === caseId ? null : caseId);
    //     setExpandedRow((prevRow) => (prevRow === caseId ? null : caseId));
    // };

    // // Checks if a row is expanded
    // const isRowExpanded = (caseId) => {
    //        return expandedRow === caseId;
    // };



    //   const handleRowExpand = (rowId) => {
    //     // Toggle between null and the clicked row's ID
    //     setExpandedRows(prevExpandedRow => prevExpandedRow === rowId ? null : rowId);
    // };

    // const isRowExpanded = (rowId) => {
    //     return expandedRows === rowId; // Check if the clicked row is expanded
    // };



    // Calculate the data to display for the current page
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    const csvData = filteredData.map(row => ({
        "Client Name": row.employerName,
        "Renewal Date": row.renewalDate,
        "Renewal Type": row.caseType,
        "Products": row.products,
        "Case Status": row.caseStatus, 
        "Salesforce Case ID": row.sfCaseId,
        "Crm Salesforce ID": row.crmSalesforceId,
        "CRM Name": row.CrmName,
        "Case Owner Name": row.caseOwnerName,
        "Renewal First Name": row.renewalContactFirstName,
        "Renewal Last Name": row.renewalContactLastName,
        "Renewal Contact Email": row.renewalContactEmail,
        "Sales Rep Name": row.salesRepName,
        "Estimated Revenue": row.clarityRevenue,
        "Current Status Date": row.updatedAt,
        "Submitted At": row.submittedAt ?? '',
        "Submitted By": row.submittedBy ?? '',
        // // "Rollout Date": row.rolloutDate,
        // "Last Rollout Error": row.lastRolloutError
    }));

    // Define the columns for the table
    const columns = [
        {
            name: 'Actions',
            selector: row => (
                <div key={row.caseId} className='d-flex align-items-center '>
                    
{row.rolloutStatus === false && (
    <div
        className="roll-button mx-2"
        style={{ cursor: 'pointer' }}
        onClick={() => handleRollClick(row.caseId)} // Attach the handler here
    >
        <span>Roll</span>
    </div>
)}
  
                     
                     <div className={`comunication-button ${isRowExpandedEmail(row.caseId) ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleRowExpandEmail(row.caseId)}>
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>

                    <div className="summary-button mx-2" style={{ cursor: 'pointer' }} onClick={() => handleCasePrint(row)}>
                        <FontAwesomeIcon icon={faFilePdf} />
                    </div>
                    <a href={row.caseType === 'COBRA'
                        ? `${config.WEB_URL}/Cobra/${row.caseId}`
                        : `${config.WEB_URL}/EmployeeBenefits/${row.caseId}`} target="_parent" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        <div className="external-link" style={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={faExternalLinkAlt} />
                        </div>
                    </a>

                    {/* <div  className="external-link" style={{ cursor: 'pointer' }}>
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </div> */}
                    {/* <div className={`circle ms-2 ${expandedRowId === row.caseId ? 'active' : ''}`}
                        onClick={() => handleRowExpand(row.caseId)} style={{ cursor: 'pointer' }}>+

                    </div> */}
                    <div className={`circle ms-2 ${isRowExpanded(row.caseId) ? 'active' : ''}`} onClick={() => handleRowExpand(row.caseId)} style={{ cursor: 'pointer' }}>
                            +
                    </div>
                     {row.caseType === "COBRA" && (
                        <></>
            // <OverlayTrigger
            //   placement="top" 
            //   overlay={
            //     <Tooltip id={`tooltip-${row.caseId}`}>Export WCC Data</Tooltip>
            //   }
            // >
            //   <div
            //     className="wcc-export-button mx-2"
            //     style={{ cursor: "pointer" }}
            //     onClick={() => handleWccExport(row)}
            //   >
            //     WCC
            //   </div>
            // </OverlayTrigger>
          )} 
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            width: '136.625px',
            sticky: 'left',
            left: '0px',
            color: ' #fff',
            textalign: 'center',
        },
        {
            name: 'Client Name',
            selector: row => row.employerName,
            key: 'employerName',
            sortable: true,
            sticky: 'left',
            style: { position: 'sticky', left: '136.25px',  width: '200.625px' }  
        },
        {
            name: 'Renewal Date',
            selector: row => row.renewalDate,
            key: 'renewalDate',
            sortable: true,
            sticky: 'left',
            style: {
                position: 'sticky',
                left: '337.531px', // Adjust this value based on the column widths
                zIndex: 3,
                backgroundColor: '#fff'
            },
            width: '200px'
        },
        { name: 'Renewal Type', key: 'caseType', selector: row => row.caseType, sortable: true },
        { name: 'Products', key: 'products', selector: row => row.products, sortable: true },
        
        { name: 'Case Status', key: 'caseStatus', selector: row => row.caseStatus, sortable: true },
        { name: 'Salesforce Case ID', key: 'sfCaseId', selector: row => row.sfCaseId, sortable: true },
        { name: 'CRM Salesforce ID', key: 'crmSalesforceId', selector: row => row.crmSalesforceId, sortable: true },
        { name: 'CRM Name', key: 'CrmName', selector: row => row.crmName, sortable: true },
        { name: 'Case Owner Name', key: 'caseOwnerName', selector: row => row.caseOwnerName, sortable: true },
        { name: 'Renewal First Name', key: 'renewalContactFirstName', selector: row => row.renewalContactFirstName, sortable: true },
        { name: 'Renewal Last Name', key: 'renewalContactLastName', selector: row => row.renewalContactLastName, sortable: true },
        { name: 'Renewal Contact Email', key: 'renewalContactEmail', selector: row => row.renewalContactEmail, sortable: true },
        { name: 'Sales Rep Name', key: 'salesRepName', selector: row => row.salesRepName, sortable: true },
        { name: 'Estimated Revenue', key: 'clarityRevenue', selector: row => row.clarityRevenue, sortable: true },
        { name: 'Submitted At', key: 'submittedAt', selector: row => formatSubmittedAt(row.submittedAt), sortable: true },
        { name: 'Submitted By', key: 'submittedBy', selector: row => row.submittedBy ?? '', sortable: true },
        
        {
           
            // name: 'Current Status Date',
            // selector: row => new Date(row.updatedAt).toISOString().split('T')[0], // Formats as YYYY-MM-DD
            // sortable: true,
            // key: 'updatedAt'
           
                name: 'Current Status Date',
                selector: row => {
                    const date = new Date(row.updatedAt);
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${month}-${day}-${year}`;
                },
                sortable: true,
                key: 'updatedAt'
            
        },
        // { name: 'Products', key: 'products', selector: row => row.products, sortable: true },
        // { name: 'Renewal Type', key: 'products', selector: row => row.caseType, sortable: true },
        // { name: 'Current Status Time', selector: row => row.updatedAt, sortable: true },
        // { name: 'Case Status', key: 'caseStatus', selector: row => row.caseStatus, sortable: true },
        // { name: 'Case Owner Name', key: 'caseOwnerName', selector: row => row.caseOwnerName, sortable: true },
        // { name: 'Salesforce Case ID', key: 'sfCaseId', selector: row => row.sfCaseId, sortable: true },
        // { name: 'Is Ready',key:'isReady', selector: row => (row.isReady ? 'Yes' : 'No') , sortable: true },
        // { name: 'CRM Name', key: 'CrmName', selector: row => row.crmName, sortable: true },
        // { name: 'Renewal Contact Email', key: 'renewalContactEmail', selector: row => row.renewalContactEmail, sortable: true },
        // { name: 'Renewal First Name', key: 'renewalContactFirstName', selector: row => row.renewalContactFirstName, sortable: true },
        // { name: 'Renewal Last Name', key: 'renewalContactLastName', selector: row => row.renewalContactLastName, sortable: true },
        // { name: 'Estimated Revenue', key: 'clarityRevenue', selector: row => row.clarityRevenue, sortable: true },
        // { name: 'Sales Rep Name', key: 'salesRepName', selector: row => row.salesRepName, sortable: true },
        // { name: 'Rollout Date',key:'rolloutDate', selector: row => row.rolloutDate, sortable: true },
        // { name: 'Last Rollout Error', key:'lastRolloutError', selector: row => row.lastRolloutError , sortable: true }
    ];

    // Total number of pages
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);




    const [visibleColumns, setVisibleColumns] = useState({
        Actions: true,
        ClientName: true,
        RenewalDate: true,
        EstimatedRevenue: true,
        SalesRepName: true,
        CRMSalesforceID: true,
        Products: true,
        RenewalType:true,
        CurrentStatusDate: true,
        SubmittedAt: true,
        SubmittedBy: true,
        CaseStatus: true,
        CaseOwnerName: true,
        SalesforceCaseID: true,
        // IsReady: true,
        CRMName: true,
        RenewalContactEmail: true,
        RenewalFirstName: true,
        RenewalLastName: true,
        // RolloutDate: true,
        // LastRolloutError: true
    });

    const toggleColumnVisibility = (name) => {
        setVisibleColumns((prevState) => ({
            ...prevState,
            [name]: !prevState[name],
        }));
    };

    const [showColumnOptions, setShowColumnOptions] = useState(false);

   
    

    return (
        <div className="card mb-4">
            <div className="card-body">
                
                <div id="dataTable_wrapper" className="dt-container dt-empty-footer">
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                        {/* Entries per page dropdown */}
                        <div className="dt-length">
                            {/* <div className="dt-length mb-2 mb-sm-0 me-3"> */}
                            <select
                                name="dataTable_length"
                                className="dt-input "
                                value={rowsPerPage}
                                onChange={handlePerPageChange}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            <label htmlFor="dt-length-0"> entries per page</label>
                        </div>

                        {/* Search input */}
                        <div className="dt-search">
                            {/* <div className="dt-search mb-2 mb-sm-0 me-3"> */}
                            <label htmlFor="dt-search-0">Search:</label>
                            <input
                                type="search"
                                className="dt-input "
                                id="dt-search-0"
                                value={searchText}
                                onChange={handleSearch}
                                placeholder=""
                            />
                        </div>

                        <div className="dt-buttons">


                            <button
                                className="dt-button buttons-collection"
                                onClick={() => setShowExportOptions(!showExportOptions)} // Toggle dropdown
                                aria-haspopup="dialog"
                                aria-expanded={showExportOptions ? 'true' : 'false'}
                            >
                                <span>Export</span>
                                <span className="dt-button-down-arrow">▼</span>
                            </button>

                            {/* Dropdown with Copy and CSV Options */}
                            {showExportOptions && (
                                <div
                                    className="dt-button-collection dtb-b2"
                                    aria-modal="true"
                                    role="dialog"
                                    style={{
                                        position: 'absolute',
                                        // top: '40px', // Position the popup directly below the button
                                        // left: '1080px',
                                        width: '200px', // Adjust this value to control horizontal positioning
                                        zIndex: 10,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        position: 'absolute',



                                    }}
                                >
                                    <div role="menu">
                                        {/* Copy Button */}
                                        <CopyToClipboard
                                            text={JSON.stringify(filteredData)} // Copy the filtered data
                                            onCopy={() => alert('Data copied to clipboard!')}

                                            className="dt-button buttons-copy buttons-html5" type="button"  >
                                            <span>Copy</span>

                                        </CopyToClipboard>
                                        
                                        <br></br>
                                        {/* CSV Export Button */}
                                        <CSVLink
                                            data={csvData}
                                            filename={"admin_data.csv"}
                                            className="dt-button buttons-csv buttons-html5"
                                            target="_blank"

                                        >
                                            <span>CSV</span>
                                        </CSVLink>
                                        
                                    </div>
                                </div>
                            )}





                            <button
                                className="dt-button buttons-collection buttons-colvis"
                                onClick={() => setShowColumnOptions(!showColumnOptions)} // Toggle dropdown
                            >
                                <span>Change columns</span>
                                <span className="dt-button-down-arrow">▼</span>
                            </button>
                            <div className="dt-button-background"  ></div>
                            {showColumnOptions && (

                                <div className="dt-button-collection " style={{
                                    zIndex: 999, border: '1px solid #ccc', position: 'absolute', backgroundColor: 'white',
                                    width: '200px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    padding: '10px',
                                    borderRadius: '5px',
                                }}>
                                    <div role="menu">
                                        {Object.keys(visibleColumns).map((name) => (
                                            <div key={name} className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={visibleColumns[name]}
                                                    onChange={() => toggleColumnVisibility(name)}
                                                    id={`checkbox-${name}`}
                                                />
                                                <label className="form-check-label" htmlFor={`checkbox-${name}`}>
                                                    {name.replace(/([A-Z])/g, ' $1').trim()}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>

                    {/* Table */}
                    <div className="dt-scroll">
                        <div className=" dt-scroll" style={{  overflowX: 'auto', position: 'relative' }}>
                            <table className="table table-striped dataTable table-bordered" style={{ minWidth: '1000px' }}>
                                <thead className="sticky-header" >
                                    <tr>
                                        {columns.map((col, index) => (
                                            visibleColumns[col.name.replace(/\s+/g, '')] && ( // Add condition for visibility
                                                <th key={index} onClick={() => col.sortable && handleSort(col.key)}
                                                    style={{
                                                        position: col.sticky ? 'sticky' : 'relative',
                                                        cursor: 'pointer',
                                                        left: col.name === 'Actions' ? '0px' :
                                                            col.name === 'Client Name' ? '136.25px' :
                                                                col.name === 'Renewal Date' ? '339px' : 'unset',
                                                        zIndex: col.sticky ? 3 : '',
                                                        whiteSpace: 'nowrap',
                                                        fontWeight: 'bold',

                                                        // border: '1px solid rgb(230, 230, 242)',
                                                        // padding: '4px 10px !important',
                                                        //  borderbottom: '5px solid rgba(0, 0, 0, 0.3)',
                                                    }}>

                                                    {col.name} {col.sortable && <FontAwesomeIcon icon={getSortIcon(col.key)} />}

                                                </th>
                                            )
                                        ))}
                                    </tr>
                                </thead>
                                {(summaryLoading || dataLoading) ? (
        
        <tbody>
        {Array(5).fill().map((_, rowIndex) => ( // Adjust the number of skeleton rows
            <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                    visibleColumns[col.name.replace(/\s+/g, '')] && ( // Add condition for visibility
                        <td key={colIndex}>
                            <Skeleton height={20} width={col.name === 'Actions' ? 50 : 150} />
                        </td>
                    )
                ))}
            </tr>
        ))}
    </tbody>
    ):( <tbody>
        {currentData.map((row) => {
           
            return (
                <React.Fragment key={row.caseId}>
                    <tr style={{ backgroundcolor: '#E6F2E6' }}>
                        {columns.map((col, colIndex) => (
                            visibleColumns[col.name.replace(/\s+/g, '')] && ( // Add condition for visibility
                                <td key={colIndex} style={{
                                    position: col.sticky ? 'sticky' : 'relative',
                                    //  left: col.sticky === 'left' ? `${colIndex * 136.625}px` : 'unset',
                                    left: col.name === 'Actions' ? '0px' :
                                        col.name === 'Client Name' ? '136.25px' :

                                            col.name === 'Renewal Date' ? '339px' : 'unset',

                                    // backgroundColor: col.sticky ? '#fff' : 'inherit',
                                    zIndex: col.sticky ? 3 : '',

                                }}>


                                    {col.selector(row)}
                                </td>
                            )
                        ))}
                    </tr>

                    {isRowExpanded(row.caseId) && (
                        <tr data-dt-row="9">
                            {/* //  <td colSpan={columns.length  }> */}
                            {/* Expanded content here */}

                            <td colSpan="20">
                                <div className="additional-info col-md-3 mb-3">
                                    <h5>Details</h5>
                                    <div className="responsive-table">
                                        <table className="table" style={{ lineheight: '' }}>
                                            <thead>
                                                <tr>
                                                    <th scope="row">Client Name</th>
                                                    <td className="impt-date"> {row.employerName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Renewal Date</th>
                                                    <td className="impt-date">{row.renewalDate}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Estimated Revenue</th>
                                                    <td className="impt-date">{row.clarityRevenue}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">CRM Salesforce ID</th>
                                                    <td className="impt-date">{row.crmSalesforceId}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Sales Rep Name</th>
                                                    <td className="impt-date">{row.salesRepName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Products</th>
                                                    <td className="impt-date">{ row.products}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Renewal Type</th>
                                                    <td className="impt-date">{row.caseType}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Current Status Date</th>
                                                    <td className="impt-date">{new Date(row.updatedAt).toISOString().split('T')[0]}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Submitted At</th>
                                                    <td className="impt-date">{formatSubmittedAt(row.submittedAt)}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Submitted By</th>
                                                    <td className="impt-date">{row.submittedBy ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Case Status</th>
                                                    <td className="impt-date">{row.caseStatus}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Case Owner Name</th>
                                                    <td className="impt-date">{row.caseOwnerName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Salesforce Case ID</th>
                                                    <td className="impt-date">{row.sfCaseId}</td>
                                                </tr>
                                                {/* <tr>
                                                    <th scope="row">Is Ready</th>
                                                    <td className="impt-date">{row.isReady}</td>
                                                </tr> */}
                                                <tr>
                                                    <th scope="row">CRM Name</th>
                                                    <td className="impt-date">{row.crmName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Renewal Contact Email</th>
                                                    <td className="impt-date">{row.renewalContactEmail}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Renewal First Name </th>
                                                    <td className="impt-date">{row.renewalContactFirstName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Renewal Last Name</th>
                                                    <td className="impt-date">{row.renewalContactLastName}</td>
                                                </tr>
                                                {/* <tr>
                                                    <th scope="row">Rollout Date</th>
                                                    <td className="impt-date">{row.rolloutDate}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Last Rollout Error</th>
                                                    <td className="impt-date">{row.lastRolloutError}</td>
                                                </tr> */}

                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    )}

                    {isRowExpandedEmail(row.caseId) && (
                        <tr data-dt-row="0">
                            <td colSpan="20">
                                <div className="additional-info col-md-5 mb-3">
                                    <h5>Communications</h5>
                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : (
                                        <div className="responsive-table mb-3">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Subject</th>
                                                        <th>Sent To</th>
                                                        <th>TemplateId</th>
                                                        <th>Sent Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {emailLogs.length > 0 ? (
                                                        emailLogs.map((log, index) => (
                                                            <tr key={index}>
                                                                <td>{log.subject}</td>
                                                                <td>{log.emailTo}</td>
                                                                <td>{log.templateId}</td>
                                                                <td>{new Date(log.createdAt).toLocaleString()}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3">No email logs available.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </td>
                        </tr>
                    )}
                </React.Fragment>
            );
        })}
    </tbody>)}
                               
                            </table>

                        </div>
                    </div>
                    {/* Pagination Controls */}
                    <div className="pagination-controls d-flex justify-content-between mt-3">
                        <div>
                            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredData.length)} of {filteredData.length} entries
                        </div>
                        <div className="pagination-buttons">
                            <button
                                className={`${currentPage === 1 ? 'disabled' : ''}`}
                                onClick={() => handlePageChange(1)}
                                disabled={currentPage === 1}
                            >
                                «
                            </button>
                            <button
                                className={`${currentPage === 1 ? 'disabled' : ''}`}
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                ‹
                            </button>
                            <span className="mx-3">Page {currentPage} of {totalPages}</span>
                            <button
                                className={` ${currentPage === totalPages ? 'disabled' : ''}`}
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                ›
                            </button>
                            <button
                                className={` ${currentPage === totalPages ? 'disabled' : ''}`}
                                onClick={() => handlePageChange(totalPages)}
                                disabled={currentPage === totalPages}
                            >
                                »
                            </button>
                        </div>
                    </div>
                </div>
            </div>
             {/* CobraSummary component to be printed */}
             
             {selectedCaseId && selectedCaseType && (
                
    <div style={{ position: 'absolute', top: '-9999px', left: '-9999px', display:'none' }}>
        {selectedCaseType === 'COBRA' ? (
            <CobraSummary caseId={selectedCaseId} ref={printFunctionRef} />
        ) : selectedCaseType === 'Employee Benefits' ? (
            <EmployeeBenefitsSummary caseId={selectedCaseId} ref={printFunctionRef} />
        ) : null}
    </div>
)}
        </div>
    );
};

export default AdminDataPanel;
